import { useRef, type HTMLAttributes, type ReactNode } from 'react';
import { useSpotlight } from './useSpotlight';

export interface SpotlightCardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  /** Maximum tilt in degrees (≤3). 0 keeps the card flat and only shows the glow. */
  tilt?: number;
}

/** Card wrapper with a cursor-follow cyan glow and ≤3° tilt on fine pointers (static on touch / reduced motion). */
export default function SpotlightCard({ children, tilt = 3, className = '', ...rest }: SpotlightCardProps) {
  const ref = useRef<HTMLDivElement>(null);
  useSpotlight(ref, { tilt });
  return (
    <div ref={ref} className={`spotlight ${tilt ? 'spotlight-tilt' : ''} relative ${className}`} {...rest}>
      {children}
      <span className="spotlight-glow" aria-hidden="true" />
    </div>
  );
}
